
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { IShortCommunity } from '@/model/Community/communityInterfaces';
import { collectErrors, fieldErrorMessages, generalErrorMessage } from '@/components/settings/identityIntegrations/integrationErrors';
import { IApiFieldError, identityIntegrationsService, IIdentityIntegration } from '@/services/identityIntegrationsService';

const communityModule = namespace('communityModule');

@Component({ name: 'ScopeCard' })
export default class ScopeCard extends Vue {
  @Prop({ required: true })
  protected integration!: IIdentityIntegration;
  @Prop({ default: false })
  protected canManage!: boolean;

  @communityModule.Getter('communityList')
  private communities!: IShortCommunity[];

  @communityModule.Action('fetchAllCommunities')
  private fetchAllCommunities!: () => void;

  protected selected: number[] = [];
  protected busy: boolean = false;
  protected errors: IApiFieldError[] = [];

  created() {
    if (!this.communities || !this.communities.length) {
      this.fetchAllCommunities();
    }
    this.reset();
  }

  @Watch('integration')
  onIntegrationChanged() {
    this.reset();
  }

  get communityItems() {
    const communities = this.communities || [];

    return communities
      .filter((community: IShortCommunity) => !community.deleted_at)
      .map((community: IShortCommunity) => ({
        text: community.name + ' (#' + community.id + ')',
        value: community.id,
      }));
  }

  get dirty(): boolean {
    const current = this.integration.community_ids.slice().sort();
    const next = this.selected.slice().sort();

    return current.length !== next.length || current.some((id, index) => id !== next[index]);
  }

  get scopeErrors(): string[] {
    const direct = fieldErrorMessages(this, this.errors, 'community_ids');
    const indexed = this.errors
      .filter((each) => !!each.ref && each.ref.indexOf('community_ids.') === 0)
      .map((each) => this.$t('identityIntegrations.errors.' + each.title) as string);

    return direct.concat(indexed);
  }

  get generalError(): string | null {
    const indexedRefs = this.errors.filter((each) => !!each.ref && each.ref.indexOf('community_ids') === 0).map((each) => each.ref as string);

    return generalErrorMessage(this, this.errors, indexedRefs);
  }

  reset() {
    this.selected = this.integration.community_ids.slice();
    this.errors = [];
  }

  async submit() {
    this.busy = true;
    this.errors = [];
    try {
      const updated = await identityIntegrationsService.replaceScope(this.integration.id, this.selected);
      this.$uiBus.emit('info', this.$t('identityIntegrations.scope.saved') as string);
      this.$emit('updated', updated);
    } catch (error) {
      this.errors = collectErrors(error);
    } finally {
      this.busy = false;
    }
  }
}
